export var Name = 'favorites-updated';
export var FavoritesUpdated = Name;